import { lazy } from '#src/lib/retry.ts';

export const TextDocument = lazy(
  async () => import('./index.tsx'),
  'TextDocument'
);
